import type { PaymentState } from '../types/payments.types';

export const initialState: PaymentState = {
  isValidEditAmount: false,
  manualBills: [],
  outstandingBills: {
    outstanding: [],
    pending: [],
  },
  paymentReceipt: {
    referenceNumber: '',
  },
  selectedCluster: {
    clusterCode: '',
    clusterName: '',
  },
};
